import DateFnsUtils from '@date-io/date-fns';
import { Box, Button, Card, CardHeader, Backdrop,CircularProgress,createMuiTheme, FormControl, Grid, InputAdornment, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import SearchIcon from '@material-ui/icons/Search';
import MuiAlert from '@material-ui/lab/Alert';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import React, { useState } from 'react';
import axios from 'src/utils/axios';
import { getDifferenceInDays, getUser, sc } from 'src/utils/Common';
import LeftPane from './LeftPane';
import RestoreIcon from '@material-ui/icons/Restore';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  container: {
    maxHeight: 650,
    minHeight: 650,
  },
  fields: {
    paddingTop: 5,
  },
  box: {
    display: "flex",
    paddingTop: 15
  },
  centerBox: {
    justifyContent: "center",
    alignItems: "center"
  },
  cardHeader: {
    height: '10px'
  },
  cardScrollUst: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    maxHeight: 650,
    minHeight: 650,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '0px solid slategrey'
    }
  }, 
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};

const entryListCells = [
  { id: 'FATURA_NO', numeric: false, disablePadding: true, label: 'FaturaNo' },
  { id: 'GIRIS_TARIH', numeric: false, disablePadding: true, label: 'GirişTarihi' },
  { id: 'MALZEME_STOK_NO', numeric: false, disablePadding: true, label: 'MalzemeStokNo' },
  { id: 'MALZEME', numeric: false, disablePadding: true, label: 'Malzeme' },
  { id: 'FATURA_ADET', numeric: true, disablePadding: true, label: 'FaturaAdet' },
  { id: 'GIRIS_ADET', numeric: true, disablePadding: true, label: 'GirişAdet' },
  { id: 'FARK', numeric: true, disablePadding: true, label: 'Fark' },
  { id: 'KULLANICI', numeric: false, disablePadding: true, label: 'Kullanıcı' },
  { id: 'KULLANICI', numeric: false, disablePadding: true, label: 'Faturayı Geçici Girişe Çevir' },
];



function RightPane(props) {
  const classes = useStyles();
  const [Loading, setLoading] = useState(false);

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = useState(today);
  const [bitisTarihi, setBitisTarihi] = useState(today);

  const [data, setData] = useState([]);
  const [oldData, setoldData] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const handleSorgula = () => {
    if (getDifferenceInDays(new Date(baslangicTarihi), new Date(bitisTarihi)) > 30) {
      setUyariTip("error");
      setUyariAciklama("İki tarih aralığı 30 günden büyük olamaz!...");
      setUyari(true);
      return
    }
    props.setLoading(true);
    const user = getUser();
    axios.get(`GetInvoiceDiff/${user.ServiceShopId}/${baslangicTarihi}/${bitisTarihi}`)
      .then(res => {
        setData(res.data);
        setoldData(res.data);
        setFiltered(res.data);
        props.setLoading(false);
      }).catch(err => {
        setData({});
        setFiltered({});
        props.setLoading(false);
      })
  }

  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => (
            <TableCell padding='none'
              key={headCell.id}
              align={'center'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [search, setSearch] = useState('');
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();

  const handleSearch = (Param) => {
    setSearch(Param);
    setFiltered(oldData.filter(item => sc(item.MALZEME_STOK_NO, Param) || sc(item.MALZEME, Param) || sc(item.FATURA_NO, Param)))
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const SetInvoiceBackAccept = (event, row, FATURA_NO) => {
    setLoading(true);
    const user = getUser();
    axios
      .get(`/SetInvoiceBackAccept/${user.ServiceShopId}/${FATURA_NO}`)
      .then(response => {
        setLoading(false);
        setUyariTip("success");
        setUyariAciklama(response.data);
        setUyari(true);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const SetInvoiceBack = (event, row, FATURA_NO) => {
    confirmAlert({
      message:
        FATURA_NO + ' numaralı faturanız geçici girişe çevirilecektir!... Devam etmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            SetInvoiceBackAccept(event, row, FATURA_NO);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };



  return (
    <div>
      <Snackbar open={uyari} autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={uyariKapat}>
        <Alert onClose={uyariKapat} severity={uyariTip}>
          {uyariAciklama || ''}
        </Alert>
      </Snackbar>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Paper>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={1} title={"Başlangıç tarihi"} >
            <FormControl variant="outlined" className={classes.fields}>
              <Typography variant="h6" component="h2">
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap['tr']}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      fullWidth
                      inputVariant="outlined"
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yy'}
                      variant="outlined"
                      value={baslangicTarihi}
                      onChange={e => handleDateChange(e, 1)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Typography>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={1} title={"Bitiş tarihi"}>
            <FormControl variant="outlined" className={classes.fields}>
              <Typography variant="h6" component="h2">
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap['tr']}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      fullWidth
                      inputVariant="outlined"
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yy'}
                      variant="outlined"
                      value={bitisTarihi}
                      onChange={e => handleDateChange(e, 2)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Typography>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={1}
            align='center'
            justify='center'
          >
            <Box
              component="div"
              m={1}
              className={`${classes.centerBox} ${classes.box}`}
            >
              <Button
                variant="contained"
                color="secondary"
                endIcon={<SearchIcon>Sorgula</SearchIcon>}
                onClick={() => handleSorgula()}>
                Sorgula
       </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={9}>
            <FormControl fullWidth className={classes.margin} style={{ paddingTop: '15px' }}>
              <TextField
                label="Arama Yapınız..."
                value={search}
                className={clsx(classes.margin, classes.textField)}
                onChange={e => handleSearch(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
      <br />
      <Paper>
        <Grid container spacing={1}>
          <Grid xs={12} sm={12} style={{ paddingRight: '10px' }}>
            <Card spacing={2}>
              <CardHeader title="Fatura Farkları" className={classes.cardHeader} />
              <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={'small'}>
                  <EnhancedTableHead
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    Header={entryListCells}
                  />
                  <TableBody>
                    {stableSort(filtered || [], getComparator(order, orderBy))
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.FATURA_NO}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.GIRIS_TARIH}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.MALZEME_STOK_NO}
                          </TableCell>
                          <TableCell padding='none' title={row.MALZEME} align="left" className={classes.tableCell}>
                            {row.MALZEME}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.FATURA_ADET}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.GIRIS_ADET}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.FARK}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.KULLANICI}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            <RestoreIcon
                              onClick={event =>
                                SetInvoiceBack(event, row, row.FATURA_NO)
                              }
                              color="primary"
                            />

                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </div>

  );
}





export default RightPane;
